<template>
  <v-autocomplete
    v-model="vmodel"
    :loading="isLoading"
    :items="items"
    :search-input.sync="search"
    cache-items
    outlined
    hide-no-data
    hide-details
    :label="label"
    :item-text="item_text"
    :item-value="item_id"
    :dark="rdark"
    :disabled="disable"
    clearable
  ></v-autocomplete>
</template>

<script>
//import Vue from "vue";
import ExecutaSQL from "../domain/ExecutaSQL";
export default {
  props: [
    "id",
    "item_text",
    "item_campos",
    "item_id",
    "item_pk",
    "item_busca",
    "item_left",
    "value",
    "tabela",
    "label",
    "rdark",
    "disable",
    "condicao",
  ],
  data: () => ({
    vmodel: null,
    isLoading: false,
    search: null,
    descriptionLimit: 60,
    entries: [],
    campo_pk: "",
    rwhere: "",
  }),
  computed: {
    fields() {
      if (!this.vmodel) return [];
      return Object.keys(this.vmodel).map((key) => {
        return {
          key,
          value: this.vmodel[key] || "n/a",
        };
      });
    },
    items() {
      return this.entries.map((entry) => {
        const Description =
          entry.nome.length > this.descriptionLimit
            ? entry.nome.slice(0, this.descriptionLimit) + "..."
            : entry.nome;
        return Object.assign({}, entry, { Description });
      });
    },
  },
  watch: {
    search(val) {
      if (val == null || typeof val == "undefined") return;
      //if (this.items.length > 0) return;

      if (val.length < 3) return;
      if (this.isLoading) return;

      this.isLoading = true;
      var wcondicao = "";
      /* 
      if (this.value != "") {
        wcondicao = " WHERE TRIM(" + this.item_id + "::text) = '" + val + "'";
      } else { */

      if (typeof this.item_busca != "undefined") {
        if (this.item_busca != "") {
          wcondicao =
            " WHERE " +
            this.item_busca +
            " LIKE '%" +
            val.toString().trim().toUpperCase() +
            "%'";
        }
      }
      //}

      if (this.rwhere != "") wcondicao += " AND " + this.rwhere;

      var wsql =
        "SELECT " +
        this.item_campos +
        " FROM " +
        this.tabela +
        " " +
        this.item_left +
        " " +
        wcondicao +
        " ORDER BY " +
        this.item_text;

      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function (tmp) {
          this.entries = tmp;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },

    vmodel(val) {
      //this.$emit("getID", { id: this.id, value: val});
      var wre = this.entries.filter((e) => {
        return e[this.item_id] == val;
      });
      var wnome = "";
      if (wre.length > 0) wnome = wre[0].nome;
      this.$emit("getID", {
        id: this.id,
        value: val,
        nome: wnome,
        dados: wre[0],
      });
    },

    value(val) {
      this.buscaDadosValue(val);
    },
  },
  created() {},
  mounted() {
    if (this.value != null && this.value != "") {
      this.buscaDadosValue(this.value);
    }

    if (typeof this.condicao != "undefined" && this.condicao != "") {
      this.rwhere = this.condicao;
    }
  },
  methods: {
    buscaDadosValue(val) {
      if (val == null || val == "") {
        this.vmodel = val;
        this.$emit("getID", { id: this.id, value: val, nome: "", dados: [] });
        return;
      }

      this.isLoading = true;

      var wcampo = this.item_id;
      if (typeof this.item_pk != "undefined") wcampo = this.item_pk;

      var wcondicao = " WHERE TRIM(" + wcampo + "::text) = '" + val + "'";
      if (this.rwhere != "") wcondicao += " AND " + this.rwhere;

      var wsql =
        "SELECT " +
        this.item_campos +
        " FROM " +
        this.tabela +
        " " +
        this.item_left +
        " " +
        wcondicao +
        " ORDER BY " +
        this.item_text;

      console.log(wsql);

      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function (tmp) {
          this.entries = tmp;
          this.vmodel = val;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
  },
};
</script>